<template>
  <v-snackbar v-model="snackbar">
      <v-icon v-if="type === 'warning'">mdi-alert</v-icon>
      <v-icon v-if="type === 'success'">mdi-check-circle</v-icon>
      <v-icon v-if="type === 'error'">mdi-alert-decagram</v-icon>
      <v-icon v-if="type === 'info'">mdi-information</v-icon>
      <span style="margin-left: 16px;">{{ text }}</span>
      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
</template>

<script>
// Toast padrão do material design
export default {
  name: 'CloseBox',
  data() {
    return {
      snackbar: false,
      text: '',
      type: 'info',
    };
  },
  methods: {
    // Mostra o toast
    openSnackbar() {
      this.snackbar = true;
    },
    setText(text) {
      this.text = text;
    },
    setType(type) {
      this.type = type;
    },
  },
  mounted() {
    document.addEventListener('snack', ({ detail }) => {
      this.setText(detail.text);
      if (detail.type) {
        this.setType(detail.type);
      }
      this.openSnackbar();
    });
  },
};
</script>
